import { useState, useEffect, useCallback, useRef } from "react";
import api from "../api";
import { t } from "../vocab";
import { guardarFunil } from "../funil";
import { useTheme } from "../components/Theme";

const CORES_GRUPO = [
  "#EE6A1A","#e2445c","#00c875","#fdab3d","#a25ddc","#037f4c",
  "#579bfc","#ff642e","#9cd326","#66ccff","#cab641","#784bd1",
];

const STATUS_PADRAO = [
  { id:"novo",             label:"Novo lead",            color:"#579bfc" },
  { id:"tentativa",        label:"Tentativa de contato", color:"#fdab3d" },
  { id:"contato_feito",    label:"Contato feito",        color:"#66ccff" },
  { id:"qualificado",      label:"Qualificado",          color:"#a25ddc" },
  { id:"reuniao_agendada", label:"Reunião agendada",     color:"#cab641" },
  { id:"proposta_enviada", label:"Proposta enviada",     color:"#784bd1" },
  { id:"convertido",       label:"Convertido",           color:"#00c875" },
  { id:"perdido",          label:"Perdido",              color:"var(--text-muted)" },
  { id:"inativo",          label:"Inativo",              color:"#e2445c" },
];
let STATUS_LEAD = (() => { try { const c = JSON.parse(localStorage.getItem("crm_funil") || "null"); if (c && Array.isArray(c.statusLead) && c.statusLead.length) return c.statusLead; } catch (e) {} return STATUS_PADRAO; })();
const TIPO_PADRAO = { novo:"novo", tentativa:"contato", contato_feito:"contato", qualificado:"contato", reuniao_agendada:"contato", proposta_enviada:"contato", convertido:"ganho", perdido:"perdido", inativo:"perdido" };
const padraoId = () => (STATUS_LEAD.find(s => s.tipo === "novo") || STATUS_LEAD[0] || { id: "novo" }).id;
const tipoDe = (id) => { const s = STATUS_LEAD.find(x => x.id === id); return s ? (s.tipo || TIPO_PADRAO[s.id] || "contato") : null; };
const nomeSemGrupo = () => "Sem grupo";

const ORIGENS = ["Instagram","Google","Google Ads","LinkedIn","WhatsApp","Facebook","Site","monday Form","Indicação","Outro"];

function fmtData(d) {
  if (!d) return "—";
  const raw = new Date(d);
  const dt = new Date(raw.getTime() + raw.getTimezoneOffset()*60000), hoje = new Date();
  const diff = Math.max(0, Math.floor((hoje-dt)/(1000*60*60*24)));
  if (diff===0) return "Hoje";
  if (diff===1) return "Ontem";
  if (diff<7)   return `${diff}d atrás`;
  return dt.toLocaleDateString("pt-BR",{day:"2-digit",month:"short"});
}

function StatusBadge({ statusLead, onChange }) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const ref = useRef();
  const st = STATUS_LEAD.find(s=>s.id===statusLead)||STATUS_LEAD[0];
  useEffect(()=>{
    const h=e=>{ if(ref.current&&!ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown",h); return()=>document.removeEventListener("mousedown",h);
  },[]);
  return (
    <div ref={ref} style={{ position:"relative", display:"inline-flex" }}>
      <div onClick={()=>setOpen(o=>!o)} style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"3px 6px", borderRadius:6, fontSize:12.5, fontWeight:500, color:st.color, cursor:"pointer", whiteSpace:"nowrap", opacity:saving?.7:1 }}>
        <span style={{ width:7, height:7, borderRadius:"50%", background:st.color, flexShrink:0 }}/>{saving?"...":st.label}
      </div>
      {open&&(
        <div style={{ position:"absolute", top:"110%", left:0, zIndex:900, background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:8, padding:6, minWidth:190, boxShadow:"0 8px 24px rgba(0,0,0,.12)" }}>
          {STATUS_LEAD.map(s=>(
            <div key={s.id} onClick={async()=>{ setOpen(false); setSaving(true); await onChange(s.id); setSaving(false); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:6, cursor:"pointer", background:statusLead===s.id?"var(--hover-bg)":"transparent" }}
              onMouseEnter={ev=>ev.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={ev=>ev.currentTarget.style.background=statusLead===s.id?"var(--hover-bg)":"transparent"}>
              <div style={{ width:10, height:10, borderRadius:2, background:s.color }}/>
              <span style={{ fontSize:13, color:"var(--text-primary)", fontWeight:statusLead===s.id?600:400 }}>{s.label}</span>
              {statusLead===s.id&&<span style={{ marginLeft:"auto", color:s.color }}>✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function OrigemBadge({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(()=>{
    const h=e=>{ if(ref.current&&!ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown",h); return()=>document.removeEventListener("mousedown",h);
  },[]);
  return (
    <div ref={ref} style={{ position:"relative" }}>
      <div onClick={()=>setOpen(o=>!o)} style={{ padding:value==="Site"?"3px 10px":"3px 4px", borderRadius:value==="Site"?99:6, fontSize:12, color: value==="Site"?"#EE6A1A":value?"var(--text-secondary)":"var(--text-muted)", background:value==="Site"?"rgba(238,106,26,.12)":"transparent", fontWeight:value==="Site"?700:400, display:"inline-block", cursor:"pointer", whiteSpace:"nowrap" }}>
        {value||"Fonte"}
      </div>
      {open&&(
        <div style={{ position:"absolute", top:"110%", left:0, zIndex:900, background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:8, padding:6, minWidth:160, boxShadow:"0 8px 24px rgba(0,0,0,.12)", maxHeight:200, overflowY:"auto" }}>
          {ORIGENS.map(o=>(
            <div key={o} onClick={()=>{ onChange(o); setOpen(false); }}
              style={{ padding:"7px 10px", borderRadius:6, cursor:"pointer", fontSize:13, color:"var(--text-primary)", fontWeight:value===o?600:400 }}
              onMouseEnter={ev=>ev.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={ev=>ev.currentTarget.style.background="transparent"}>
              {o}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function IE({ value, onChange, placeholder="", style:s={} }) {
  const [edit, setEdit] = useState(false);
  const [val,  setVal]  = useState(value||"");
  const ref = useRef();
  useEffect(()=>setVal(value||""),[value]);
  useEffect(()=>{ if(edit&&ref.current) ref.current.focus(); },[edit]);
  const commit=()=>{ setEdit(false); if(String(val)!==String(value||"")) onChange(val); };
  if(edit) return (
    <input ref={ref} value={val} onChange={e=>setVal(e.target.value)}
      onBlur={commit} onKeyDown={e=>{ if(e.key==="Enter")commit(); if(e.key==="Escape"){setVal(value||"");setEdit(false);} }}
      style={{ background:"transparent", border:"none", borderBottom:"1.5px solid #EE6A1A", outline:"none", color:"var(--text-primary)", fontSize:13, width:"100%", padding:"1px 0", fontFamily:"'Inter',sans-serif", ...s }}/>
  );
  return (
    <div onClick={()=>setEdit(true)} style={{ cursor:"text", fontSize:13, color:value?"var(--text-primary)":"var(--text-muted)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", padding:"2px 4px", borderRadius:4, ...s }}
      onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
      {value||placeholder}
    </div>
  );
}


function DataInline({ value, onChange, stale }) {
  const [edit, setEdit] = useState(false);
  const val = value ? new Date(value).toISOString().slice(0,10) : "";
  if (edit) return (
    <input type="date" defaultValue={val} autoFocus
      onBlur={e=>{ setEdit(false); if(e.target.value!==val) onChange(e.target.value); }}
      onChange={e=>{ if(e.target.value!==val){ onChange(e.target.value); setEdit(false); } }}
      style={{ fontSize:12, border:"1.5px solid #EE6A1A", borderRadius:4, padding:"2px 4px", outline:"none", fontFamily:"'Inter',sans-serif" }}/>
  );
  return (
    <span onClick={()=>setEdit(true)} style={{ fontSize:12, color: stale?"#E24B4A":(value?"var(--text-secondary)":"var(--text-muted)"), fontWeight: stale?600:400, cursor:"pointer", padding:"2px 6px", borderRadius:4 }}
      onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
      {value ? fmtData(value) : "+ data"}
    </span>
  );
}

function ModalGrupo({ grupo, onClose, onSave, onDelete }) {
  const isNew = !grupo?._id;
  const [label, setLabel] = useState(grupo?.label||"");
  const [color, setColor] = useState(grupo?.color||CORES_GRUPO[0]);
  const [load, setLoad]   = useState(false);
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:"var(--card-bg)", borderRadius:12, padding:24, width:360, boxShadow:"0 16px 48px rgba(0,0,0,.18)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
          <h3 style={{ margin:0, fontSize:16, fontWeight:700, color:"var(--text-primary)" }}>{isNew?"Novo grupo":"Editar grupo"}</h3>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--text-secondary)", fontSize:18 }}>×</button>
        </div>
        <input value={label} onChange={e=>setLabel(e.target.value)} placeholder="Nome do grupo..."
          style={{ width:"100%", boxSizing:"border-box", background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"10px 12px", color:"var(--text-primary)", fontSize:14, outline:"none", fontFamily:"'Inter',sans-serif", marginBottom:14 }}
          onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"} autoFocus/>
        <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:20 }}>
          {CORES_GRUPO.map(c=>(
            <div key={c} onClick={()=>setColor(c)} style={{ width:26, height:26, borderRadius:6, background:c, cursor:"pointer", border:color===c?"3px solid var(--text-primary)":"3px solid transparent", boxSizing:"border-box" }}/>
          ))}
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={async()=>{ if(!label.trim())return; setLoad(true); try{await onSave({...grupo,label,color}); onClose();}finally{setLoad(false);} }} disabled={load||!label.trim()}
            style={{ flex:1, background:color, border:"none", borderRadius:8, padding:"10px 0", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer" }}>
            {load?"...":"Salvar"}
          </button>
          {!isNew&&<button onClick={()=>{ onDelete(grupo._id); onClose(); }} style={{ background:"#feecec", border:"none", borderRadius:8, padding:"10px 14px", color:"#e2445c", fontWeight:600, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

function ModalLead({ lead, grupos, onClose, onSave, onDelete }) {
  const isNew = !lead?._id;
  const [form, setForm] = useState({
    nome:lead?.nome||"", empresa:lead?.empresa||"", telefone:lead?.telefone||"",
    email:lead?.email||"", cargo:lead?.cargo||"", origem:lead?.origem||"Instagram",
    statusLead:lead?.statusLead||padraoId(), comentarios:lead?.comentarios||"",
    grupoLeadId:lead?.grupoLeadId||"", grupoLeadLabel:lead?.grupoLeadLabel||"",
    ultimaInteracao:lead?.ultimaInteracao?new Date(lead.ultimaInteracao).toISOString().slice(0,10):"",
  });
  const [nota, setNota] = useState("");
  const [load, setLoad] = useState(false);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={ width:"100%", boxSizing:"border-box", background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"9px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", zIndex:1000, display:"flex", alignItems:"stretch", justifyContent:"flex-end" }} onClick={onClose}>
      <div style={{ background:"var(--card-bg)", borderRadius:"16px 0 0 16px", padding:28, width:"100%", maxWidth:440, height:"100vh", overflowY:"auto", boxShadow:"-12px 0 40px rgba(0,0,0,.25)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <h2 style={{ margin:0, fontSize:18, fontWeight:700, color:"var(--text-primary)" }}>{isNew?t("Novo lead"):t("Editar lead")}</h2>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--text-secondary)", fontSize:20 }}>×</button>
        </div>

        {/* Status */}
        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Status</label>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
            {STATUS_LEAD.map(s=>(
              <button key={s.id} onClick={()=>set("statusLead",s.id)}
                style={{ padding:"4px 12px", borderRadius:6, fontSize:12, fontWeight:600, cursor:"pointer", border:`1.5px solid ${form.statusLead===s.id?s.color:"var(--border-color)"}`, background:form.statusLead===s.id?s.color+"18":"var(--card-bg)", color:form.statusLead===s.id?s.color:"var(--text-secondary)" }}>
                {s.label}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Grupo</label>
            <select value={form.grupoLeadId||""} onChange={e=>{ const g=grupos.find(x=>x._id===e.target.value); set("grupoLeadId",e.target.value); set("grupoLeadLabel",g?.label||""); }} style={{ ...inp, appearance:"auto" }}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}>
              <option value="">{nomeSemGrupo()}</option>
              {grupos.map(g=><option key={g._id} value={g._id}>{g.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Fonte</label>
            <select value={form.origem} onChange={e=>set("origem",e.target.value)} style={{ ...inp, appearance:"auto" }}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}>
              {ORIGENS.map(o=><option key={o}>{o}</option>)}
            </select>
          </div>
          {[["Nome *","nome"],["Empresa","empresa"],["Cargo","cargo"],["Email","email"],["Telefone","telefone"]].map(([label,key])=>(
            <div key={key}>
              <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp}
                onFocus={e=>{ e.target.style.borderColor="#EE6A1A"; e.target.style.boxShadow="0 0 0 3px #EE6A1A18"; }}
                onBlur={e=>{ e.target.style.borderColor="var(--border-color)"; e.target.style.boxShadow="none"; }}/>
            </div>
          ))}
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Última interação</label>
            <input type="date" value={form.ultimaInteracao||""} onChange={e=>set("ultimaInteracao",e.target.value)} style={inp}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Comentários</label>
          <textarea value={form.comentarios||""} onChange={e=>set("comentarios",e.target.value)} rows={2} style={{ ...inp, resize:"vertical" }}
            onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
        </div>

        {!isNew&&lead?.atividades?.length>0&&(
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Histórico</label>
            {[...lead.atividades].reverse().slice(0,3).map((a,i)=>(
              <div key={i} style={{ background:"var(--hover-bg)", borderRadius:8, padding:"8px 12px", marginBottom:6 }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                  <span style={{ color:"#EE6A1A", fontWeight:600, fontSize:12 }}>{a.nomeUsuario}</span>
                  <span style={{ fontSize:11, color:"var(--text-secondary)" }}>{new Date(a.createdAt).toLocaleDateString("pt-BR")}</span>
                </div>
                <div style={{ fontSize:13, color:"var(--text-primary)" }}>{a.descricao}</div>
              </div>
            ))}
          </div>
        )}

        {!isNew&&(
          <div style={{ display:"flex", gap:8, marginBottom:14 }}>
            <input value={nota} onChange={e=>setNota(e.target.value)} placeholder="Adicionar nota..." style={{ ...inp, flex:1 }}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
            <button onClick={async()=>{ if(!nota.trim()) return; await api.post(`/leads/${lead._id}/atividades`,{tipo:"nota",descricao:nota}); setNota(""); onClose(); }}
              style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 14px", color:"#fff", cursor:"pointer", fontSize:13, fontWeight:700 }}>+</button>
          </div>
        )}

        <div style={{ display:"flex", gap:8 }}>
          <button onClick={async()=>{ if(!form.nome.trim()) return alert("Nome obrigatório"); setLoad(true); try{await onSave({...lead,...form,tipo:"lead",stage:"prospeccao"});}finally{setLoad(false);} }} disabled={load}
            style={{ flex:1, background:"#EE6A1A", border:"none", borderRadius:8, padding:"12px 0", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", opacity:load?.7:1 }}>
            {load?"Salvando...":"Salvar"}
          </button>
          {!isNew&&<button onClick={()=>onDelete(lead._id)} style={{ background:"#feecec", border:"1px solid #f9d3d3", borderRadius:8, padding:"12px 16px", color:"#e2445c", fontWeight:600, fontSize:13, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

export default function Leads({ currentUser }) {
  const [, setFunilVer] = useState(0);
  useEffect(() => { api.get("/funil").then(r => { const l = r.data && r.data.statusLead; if (Array.isArray(l) && l.length) { STATUS_LEAD = l; guardarFunil(r.data); setFunilVer(v => v + 1); } }).catch(() => {}); }, []);
  const { theme } = useTheme();
  const [leads,    setLeads]   = useState([]);
  const [grupos,   setGrupos]  = useState([]);
  const [loading,  setLoading] = useState(true);
  const [search,   setSearch]  = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  const [filtroFonte,  setFiltroFonte]  = useState("");
  const [modal,    setModal]   = useState(null);
  const [modalGrupo, setModalGrupo]     = useState(null);
  const [novaLinha,  setNovaLinha]      = useState(null);
  const [colapsados, setColapsados]     = useState({});
  const [selected,   setSelected]       = useState([]);
  const [dragId,     setDragId]         = useState(null);
  const [dragOver,   setDragOver]       = useState(null);
  const [menuId,     setMenuId]         = useState(null);
  const [menuPos,    setMenuPos]        = useState({x:0,y:0});

  const carregar = useCallback(async()=>{
    try{
      const [lr,gr] = await Promise.all([
        api.get("/leads?limit=1000&tipo=lead"),
        api.get("/grupos-lead"),
      ]);
      setLeads(lr.data.leads);
      setGrupos(gr.data.grupos);
    }catch{}finally{ setLoading(false); }
  },[]);

  useEffect(()=>{ carregar(); },[carregar]);

  const atualizarCampo = async(id,k,v)=>{
    const{data}=await api.put(`/leads/${id}`,{[k]:v});
    setLeads(prev=>prev.map(l=>l._id===id?{...l,...data}:l));
  };
  const atualizarStatus = async(id,statusLead)=>{
    await api.put(`/leads/${id}`,{statusLead});
    setLeads(prev=>prev.map(l=>l._id===id?{...l,statusLead}:l));
  };
  const moverGrupo = async(leadId,grupoId,grupoLabel)=>{
    await api.put(`/leads/${leadId}`,{grupoLeadId:grupoId||null,grupoLeadLabel:grupoLabel||null});
    setLeads(prev=>prev.map(l=>l._id===leadId?{...l,grupoLeadId:grupoId||null,grupoLeadLabel:grupoLabel||null}:l));
  };
  const salvarGrupo = async(f)=>{
    if(f._id){ const{data}=await api.put(`/grupos-lead/${f._id}`,f); setGrupos(prev=>prev.map(g=>g._id===data._id?data:g)); }
    else{ const{data}=await api.post("/grupos-lead",f); setGrupos(prev=>[...prev,data]); }
  };
  const excluirGrupo = async(id)=>{ if (!window.confirm("Excluir este grupo? Os leads dele ficam sem grupo.")) return;
    await api.delete(`/grupos-lead/${id}`);
    setGrupos(prev=>prev.filter(g=>g._id!==id));
    setLeads(prev=>prev.map(l=>String(l.grupoLeadId)===String(id)?{...l,grupoLeadId:null,grupoLeadLabel:null}:l));
  };
  const salvarLead = async(f)=>{
    const limpo={ ...f,
      grupoLeadId: f.grupoLeadId || null,
      ultimaInteracao: f.ultimaInteracao || null,
    };
    if(f._id){ const{data}=await api.put(`/leads/${f._id}`,limpo); setLeads(prev=>prev.map(l=>l._id===data._id?data:l)); }
    else{ const{data}=await api.post("/leads",{...limpo,tipo:"lead",stage:"prospeccao"}); setLeads(prev=>[data,...prev]); }
    setModal(null);
  };
  const excluirLead = async(id)=>{ if (!window.confirm("Excluir este lead?")) return; await api.delete(`/leads/${id}`); setLeads(prev=>prev.filter(l=>l._id!==id)); setModal(null); };
  const converterNegociacao = async(id)=>{ const l=leads.find(x=>x._id===id); if(l && !window.confirm(`Converter "${l.nome||"lead"}" em negociação?`)) return; await api.put(`/leads/${id}`,{ tipo:"negociacao", stage:"prospeccao", etapaNegociacao:"Prospecção" }); setLeads(prev=>prev.filter(x=>x._id!==id)); setModal(null); };
  const adicionarInline = async(nome,grupoId,grupoLabel)=>{
    const{data}=await api.post("/leads",{nome,tipo:"lead",stage:"prospeccao",origem:"Instagram",statusLead:padraoId(),grupoLeadId:grupoId||null,grupoLeadLabel:grupoLabel||null});
    setLeads(prev=>[data,...prev]); setNovaLinha(null);
  };

  const PAD = padraoId();
  const tipoLead = (l)=> tipoDe(l.statusLead||PAD) || "novo";
  const filtered  = leads.filter(l=>{ const q=search.toLowerCase(); const okq=!q||l.nome?.toLowerCase().includes(q)||l.empresa?.toLowerCase().includes(q)||l.email?.toLowerCase().includes(q); const st=l.statusLead||PAD; const tp=tipoLead(l); const okS=!filtroStatus||(filtroStatus==="novo"?tp==="novo":filtroStatus==="contato"?tp==="contato":filtroStatus==="convertido"?tp==="ganho":st===filtroStatus); const okF=!filtroFonte||(l.origem||"")===filtroFonte; return okq&&okS&&okF; });
  const cNovos = leads.filter(l=>tipoLead(l)==="novo").length;
  const cContato = leads.filter(l=>tipoLead(l)==="contato").length;
  const cConv = leads.filter(l=>tipoLead(l)==="ganho").length;
  const convPct = leads.length ? (Math.round(cConv/leads.length*1000)/10) : 0;
  const fontesTodas = [...new Set(leads.map(l=>l.origem).filter(Boolean))].sort();
  const porGrupo  = (id)=>filtered.filter(l=>String(l.grupoLeadId)===String(id));
  const semGrupo  = filtered.filter(l=>!l.grupoLeadId);
  const todosGrupos = [...grupos, ...(semGrupo.length>0?[{_id:"__sem__",label:nomeSemGrupo(),color:"var(--text-muted)",_virtual:true}]:[])];

  // Resumo por status
  const resumo = STATUS_LEAD.map(s=>({ ...s, count: leads.filter(l=>l.statusLead===s.id||(!l.statusLead&&s.id===PAD)).length })).filter(s=>s.count>0);

  const TH=({w,children,center})=>(
    <th style={{ padding:"10px 14px", fontSize:10.5, fontWeight:500, color:"var(--text-muted)", letterSpacing:".05em", textTransform:"uppercase", textAlign:center?"center":"left", width:w, minWidth:w, borderBottom:"1px solid var(--border-color)", whiteSpace:"nowrap" }}>{children}</th>
  );
  const TD=({w,children,center,style:s={}})=>(
    <td style={{ padding:"0 14px", height:44, borderBottom:"1px solid var(--border-light)", width:w, minWidth:w, textAlign:center?"center":"left", verticalAlign:"middle", ...s }}>{children}</td>
  );

  return (
    <div style={{ fontFamily:"'Inter',-apple-system,sans-serif", background:"var(--hover-bg)", minHeight:"100vh" }} onClick={()=>setMenuId(null)}>

      {/* Header */}
      <div style={{ background:"var(--card-bg)", borderBottom:"1px solid var(--border-color)", padding:"16px 24px 0" }}>
        {/* Banner selecionados */}
        {selected.length>0&&(
          <div style={{ background:"#FDE7DA", border:"1px solid #bdd9f7", borderRadius:8, padding:"8px 14px", marginBottom:12, display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <span style={{ fontSize:13, fontWeight:600, color:"#EE6A1A" }}>{selected.length} selecionado{selected.length>1?"s":""}</span>
            <span style={{ fontSize:13, color:"var(--text-secondary)" }}>Mover para:</span>
            {grupos.map(g=>(
              <button key={g._id} onClick={async()=>{ await Promise.all(selected.map(id=>moverGrupo(id,g._id,g.label))); setSelected([]); }}
                style={{ background:g.color+"22", border:`1px solid ${g.color}44`, borderRadius:6, padding:"3px 12px", color:g.color, fontSize:12, fontWeight:600, cursor:"pointer" }}>{g.label}</button>
            ))}
            <button onClick={()=>setSelected([])} style={{ marginLeft:"auto", background:"none", border:"none", color:"var(--text-secondary)", fontSize:12, cursor:"pointer", textDecoration:"underline" }}>Cancelar</button>
          </div>
        )}

        {/* Cards-filtro */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, padding:"4px 0 12px" }}>
          {[["novo","Novos","#579bfc",cNovos,null],["contato","Em contato","#EBA13A",cContato,null],["convertido","Convertidos","#1D9E75",cConv,convPct+"%"],["","Total de leads","#98A2B3",leads.length,null]].map(([id,label,cor,count,sub])=>{
            const ativo=filtroStatus===id;
            return (
              <div key={label} onClick={()=>setFiltroStatus(id)} style={{ cursor:"pointer", background:"var(--card-bg)", border: ativo?"2px solid #EE6A1A":"1px solid var(--border-color)", borderRadius:12, padding:"12px 16px", transition:"all .1s" }}>
                <div style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, color:"var(--text-secondary)" }}>{id&&<span style={{ width:8, height:8, borderRadius:"50%", background:cor }}/>}{label}</div>
                <div style={{ fontSize:24, fontWeight:800, color: id==="convertido"?"#1D9E75":"var(--text-primary)", marginTop:4 }}>{count}{sub&&<span style={{ fontSize:12, color:"var(--text-muted)", fontWeight:400 }}> · {sub}</span>}</div>
              </div>
            );
          })}
        </div>

        {/* Toolbar */}
        <div style={{ display:"flex", gap:10, padding:"0 0 12px", alignItems:"center" }}>
          <input placeholder="🔍 Pesquisar lead..." value={search} onChange={e=>setSearch(e.target.value)}
            style={{ background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"7px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", width:220, fontFamily:"'Inter',sans-serif" }}
            onFocus={e=>{ e.target.style.borderColor="#EE6A1A"; e.target.style.background="var(--card-bg)"; }}
            onBlur={e=>{ e.target.style.borderColor="var(--border-color)"; e.target.style.background="var(--hover-bg)"; }}/>
          <span style={{ fontSize:13, color:"var(--text-secondary)" }}>{filtered.length} lead{filtered.length!==1?"s":""}</span>
          <select value={filtroFonte} onChange={e=>setFiltroFonte(e.target.value)} style={{ background:"var(--card-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"7px 10px", color:"var(--text-secondary)", fontSize:13, cursor:"pointer", outline:"none" }}>
            <option value="">Todas as fontes</option>
            {fontesTodas.map(fte=><option key={fte} value={fte}>{fte}</option>)}
          </select>
          {(filtroStatus||filtroFonte)&&<button onClick={()=>{ setFiltroStatus(""); setFiltroFonte(""); }} style={{ background:"none", border:"none", color:"var(--text-secondary)", fontSize:12, cursor:"pointer", textDecoration:"underline" }}>Limpar</button>}
          <div style={{ marginLeft:"auto", display:"flex", gap:8 }}>
            <button onClick={()=>setModalGrupo({})} style={{ background:"var(--card-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"7px 14px", color:"var(--text-primary)", fontWeight:600, fontSize:13, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={e=>e.currentTarget.style.background="var(--card-bg)"}>
              + Novo grupo
            </button>
            <button onClick={()=>setModal({})} style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"7px 18px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", boxShadow:"0 2px 8px #EE6A1A44" }}
              onMouseEnter={e=>e.currentTarget.style.background="#0060c0"}
              onMouseLeave={e=>e.currentTarget.style.background="#EE6A1A"}>
              + Criar lead
            </button>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div style={{ overflowX:"auto", padding:"16px 0 48px" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", tableLayout:"fixed", minWidth:900 }}>
          <thead>
            <tr>
              <TH w={36}><input type="checkbox" onChange={e=>setSelected(e.target.checked?leads.map(l=>l._id):[])}/></TH>
              <TH w={"32%"}>Lead</TH>
              <TH w={"14%"}>Status</TH>
              <TH w={"18%"}>Contato</TH>
              <TH w={"13%"}>Fonte</TH>
              <TH w={"16%"} center>Última interação</TH>
              <TH w={44} center/>
            </tr>
          </thead>

          {loading&&<tbody><tr><td colSpan={7} style={{ padding:60, textAlign:"center", color:"var(--text-secondary)" }}>Carregando...</td></tr></tbody>}

          {!loading&&todosGrupos.map(grupo=>{
            const gLeads = grupo._id==="__sem__" ? semGrupo : porGrupo(grupo._id);
            const col    = colapsados[grupo._id];
            const over   = dragOver===grupo._id;

            return (
              <tbody key={grupo._id}
                onDragOver={e=>{ e.preventDefault(); setDragOver(grupo._id); }}
                onDragLeave={()=>setDragOver(null)}
                onDrop={e=>{ e.preventDefault(); const id=e.dataTransfer.getData("leadId"); if(id) moverGrupo(id,grupo._id==="__sem__"?null:grupo._id,grupo._id==="__sem__"?null:grupo.label); setDragOver(null); setDragId(null); }}>

                <tr>
                  <td colSpan={7} style={{ padding:0, background:over?grupo.color+"12":"transparent" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 12px", borderLeft:`4px solid ${grupo.color}`, borderBottom:`2px solid ${grupo.color}22`, userSelect:"none" }}>
                      <span onClick={()=>setColapsados(c=>({...c,[grupo._id]:!c[grupo._id]}))} style={{ color:grupo.color, cursor:"pointer", fontSize:14, transform:col?"rotate(-90deg)":"rotate(0)", transition:"transform .2s", display:"inline-block" }}>▾</span>
                      <span style={{ fontWeight:700, color:grupo.color, fontSize:14 }}>{grupo.label}</span>
                      <span style={{ background:grupo.color+"20", color:grupo.color, borderRadius:99, fontSize:11, fontWeight:700, padding:"1px 8px" }}>{gLeads.length}</span>
                      {over&&<span style={{ fontSize:12, color:grupo.color, fontWeight:600 }}>↓ Soltar aqui</span>}
                      {!grupo._virtual&&(
                        <button onClick={()=>setModalGrupo(grupo)} style={{ background:"none", border:"none", color:"var(--text-muted)", cursor:"pointer", fontSize:12, padding:"2px 8px", borderRadius:6 }}
                          onMouseEnter={e=>{ e.currentTarget.style.color=grupo.color; e.currentTarget.style.background=grupo.color+"12"; }}
                          onMouseLeave={e=>{ e.currentTarget.style.color="var(--text-muted)"; e.currentTarget.style.background="none"; }}>
                          ✏️
                        </button>
                      )}
                    </div>
                  </td>
                </tr>

                {!col&&novaLinha===grupo._id&&(
                  <tr style={{ background:"var(--hover-bg)" }}>
                    <td style={{ padding:"8px 10px" }}><input type="checkbox" disabled/></td>
                    <td colSpan={2} style={{ padding:"8px 12px" }}>
                      <input autoFocus placeholder="Nome do lead... (Enter para salvar)"
                        onKeyDown={e=>{ if(e.key==="Enter"&&e.target.value.trim()) adicionarInline(e.target.value.trim(),grupo._id==="__sem__"?null:grupo._id,grupo._id==="__sem__"?null:grupo.label); if(e.key==="Escape") setNovaLinha(null); }}
                        style={{ background:"transparent", border:"none", borderBottom:"1.5px solid #EE6A1A", outline:"none", color:"var(--text-primary)", fontSize:13, width:"100%", padding:"2px 0", fontFamily:"'Inter',sans-serif" }}/>
                    </td>
                    <td colSpan={4} style={{ padding:"8px 12px" }}>
                      <span style={{ fontSize:11, color:"var(--text-muted)" }}>↵ Enter · Esc para cancelar</span>
                    </td>
                  </tr>
                )}

                {!col&&gLeads.map(lead=>{
                  const sel  = selected.includes(lead._id);
                  const drag = dragId===lead._id;
                  const waLink = lead.telefone?`https://wa.me/55${lead.telefone.replace(/\D/g,"")}`:"";
                  const stc = (STATUS_LEAD.find(x=>x.id===(lead.statusLead||padraoId()))||{}).color || "#98A2B3";
                  const ini = (lead.nome||"?").trim().split(/\s+/).map(w=>w[0]||"").slice(0,2).join("").toUpperCase();
                  const _di = lead.ultimaInteracao ? Math.floor((Date.now()-new Date(lead.ultimaInteracao))/86400000) : null;
                  const stale = _di!=null && _di>30;
                  const doSite = lead.origem==="Site"; const ehTeste = String(lead.servico||"").indexOf("Teste gratis")>=0;
                  const bgBase = doSite ? "linear-gradient(rgba(238,106,26,.07),rgba(238,106,26,.07)), var(--card-bg)" : "var(--card-bg)";
                  return (
                    <tr key={lead._id} draggable
                      onDragStart={e=>{ e.dataTransfer.setData("leadId",lead._id); setDragId(lead._id); }}
                      onDragEnd={()=>setDragId(null)}
                      style={{ background:sel?"var(--active-bg)":drag?"var(--hover-bg)":bgBase, opacity:drag?.6:1 }}
                      onMouseEnter={e=>{ if(!sel&&!drag) e.currentTarget.style.background="var(--hover-bg)"; }}
                      onMouseLeave={e=>{ e.currentTarget.style.background=sel?"var(--active-bg)":drag?"var(--hover-bg)":bgBase; }}>

                      <TD w={36} center style={doSite?{ boxShadow:"inset 3px 0 0 #EE6A1A" }:{}}>
                        <input type="checkbox" checked={sel} onChange={()=>setSelected(prev=>prev.includes(lead._id)?prev.filter(x=>x!==lead._id):[...prev,lead._id])} onClick={e=>e.stopPropagation()}/>
                      </TD>
                      <TD>
                        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <span style={{ color:"var(--text-muted)", fontSize:13, cursor:"grab", flexShrink:0 }}>⠿</span>
                          <span style={{ width:28, height:28, borderRadius:"50%", background:stc+"22", color:stc, display:"inline-flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:11, flexShrink:0 }}>{ini}</span>
                          <div onClick={()=>setModal(lead)} style={{ flex:1, overflow:"hidden", cursor:"pointer" }}>
                            <div style={{ fontWeight:600, color:"var(--text-primary)", fontSize:13, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{lead.nome||"—"}{ehTeste&&<span style={{ marginLeft:8, fontSize:10, fontWeight:700, color:"#fff", background:"#EE6A1A", padding:"2px 7px", borderRadius:99, verticalAlign:"middle", letterSpacing:".02em" }}>TESTE GRÁTIS</span>}</div>
                            {lead.empresa&&<div style={{ fontSize:11, color:"var(--text-secondary)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{lead.empresa}</div>}
                          </div>
                        </div>
                      </TD>
                      <TD w={140}>
                        <StatusBadge statusLead={lead.statusLead||padraoId()} onChange={v=>atualizarStatus(lead._id,v)}/>
                      </TD>
                      <TD w={210}>
                        <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                          {lead.telefone&&<span style={{ fontSize:12, flexShrink:0 }}>🇧🇷</span>}
                          <span style={{ color:"var(--text-primary)", fontSize:12, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{lead.telefone||"—"}</span>
                          {lead.telefone&&<a href={`tel:${lead.telefone.replace(/[^0-9]/g,"")}`} onClick={e=>e.stopPropagation()} title="Ligar" style={{ color:"var(--text-secondary)", fontSize:12, flexShrink:0, textDecoration:"none" }}>📞</a>}{waLink&&<a href={waLink} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} title="WhatsApp" style={{ color:"#25d366", fontSize:13, flexShrink:0, textDecoration:"none" }}>💬</a>}
                        </div>
                      </TD>
                      <TD w={130}>
                        <OrigemBadge value={lead.origem} onChange={v=>atualizarCampo(lead._id,"origem",v)}/>
                      </TD>
                      <TD w={120} center>
                        <DataInline value={lead.ultimaInteracao} onChange={v=>atualizarCampo(lead._id,"ultimaInteracao",v)} stale={stale}/>
                      </TD>
                      <TD w={44} center>
                        <button onClick={e=>{ e.stopPropagation(); setMenuId(lead._id); setMenuPos({x:e.clientX,y:e.clientY}); }}
                          style={{ background:"none", border:"none", color:"var(--text-muted)", cursor:"pointer", fontSize:18, borderRadius:4, width:28, height:28, display:"flex", alignItems:"center", justifyContent:"center" }}
                          onMouseEnter={e=>{ e.currentTarget.style.background="var(--border-light)"; e.currentTarget.style.color="var(--text-primary)"; }}
                          onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color="var(--text-muted)"; }}>⋮</button>
                      </TD>
                    </tr>
                  );
                })}

                {!col&&(
                  <tr>
                    <td colSpan={7} style={{ padding:"6px 12px", borderBottom:"1px solid var(--border-light)", background:"var(--hover-bg)" }}>
                      <button onClick={()=>setNovaLinha(grupo._id)} style={{ background:"none", border:"none", color:"var(--text-muted)", cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:6, padding:"4px 6px", borderRadius:6, fontFamily:"'Inter',sans-serif" }}
                        onMouseEnter={e=>{ e.currentTarget.style.color=grupo.color; e.currentTarget.style.background=grupo.color+"10"; }}
                        onMouseLeave={e=>{ e.currentTarget.style.color="var(--text-muted)"; e.currentTarget.style.background="none"; }}>
                        + Adicionar lead
                      </button>
                    </td>
                  </tr>
                )}

                {!col&&gLeads.length>0&&(
                  <tr style={{ background:grupo.color+"06" }}>
                    <td colSpan={7} style={{ padding:"8px 12px", fontSize:12, color:"var(--text-secondary)", fontWeight:500, borderBottom:"1px solid var(--border-color)" }}>
                      {gLeads.length} lead{gLeads.length!==1?"s":""}
                    </td>
                  </tr>
                )}

                <tr><td colSpan={7} style={{ height:6, background:"var(--hover-bg)" }}/></tr>
              </tbody>
            );
          })}
        </table>

        <div style={{ padding:"8px 24px" }}>
          <button onClick={()=>setModalGrupo({})} style={{ background:"none", border:"1.5px dashed #d0d2d9", borderRadius:8, padding:"10px 20px", color:"var(--text-secondary)", cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:8, fontFamily:"'Inter',sans-serif", width:"100%" }}
            onMouseEnter={e=>{ e.currentTarget.style.borderColor="#EE6A1A"; e.currentTarget.style.color="#EE6A1A"; }}
            onMouseLeave={e=>{ e.currentTarget.style.borderColor="#d0d2d9"; e.currentTarget.style.color="var(--text-secondary)"; }}>
            + Adicionar novo grupo
          </button>
        </div>
      </div>

      {/* Menu ⋮ */}
      {menuId&&(
        <div style={{ position:"fixed", top:Math.min(menuPos.y, window.innerHeight-280), left:menuPos.x>window.innerWidth-230?menuPos.x-220:menuPos.x, zIndex:3000 }} onClick={e=>e.stopPropagation()}>
          <div style={{ background:"var(--card-bg)", border:"1px solid var(--border-color)", borderRadius:10, padding:6, minWidth:200, boxShadow:"0 8px 24px rgba(0,0,0,.12)" }}>
            <div style={{ fontSize:11, color:"var(--text-secondary)", fontWeight:600, letterSpacing:".05em", textTransform:"uppercase", padding:"6px 10px 4px" }}>Mover para</div>
            <div onClick={()=>{ moverGrupo(menuId,null,null); setMenuId(null); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:6, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{ width:10, height:10, borderRadius:2, background:"var(--text-muted)" }}/><span style={{ fontSize:13, color:"var(--text-primary)" }}>{nomeSemGrupo()}</span>
            </div>
            {grupos.map(g=>(
              <div key={g._id} onClick={()=>{ moverGrupo(menuId,g._id,g.label); setMenuId(null); }}
                style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:6, cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{ width:10, height:10, borderRadius:2, background:g.color }}/><span style={{ fontSize:13, color:"var(--text-primary)" }}>{g.label}</span>
              </div>
            ))}
            <div style={{ borderTop:"1px solid var(--border-color)", margin:"4px 0" }}/>
            <div onClick={()=>{ const l=leads.find(x=>x._id===menuId); setModal(l); setMenuId(null); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:6, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span style={{ fontSize:13, color:"var(--text-primary)" }}>✏️ Editar lead</span>
            </div>
            <div onClick={()=>{ converterNegociacao(menuId); setMenuId(null); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", borderRadius:6, cursor:"pointer" }}
              onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span style={{ fontSize:13, color:"#1D9E75", fontWeight:600 }}>→ Converter em negociação</span>
            </div>
          </div>
        </div>
      )}

      {modal!==null&&<ModalLead lead={Object.keys(modal).length?modal:null} grupos={grupos} onClose={()=>setModal(null)} onSave={salvarLead} onDelete={excluirLead}/>}
      {modalGrupo!==null&&<ModalGrupo grupo={Object.keys(modalGrupo).length?modalGrupo:null} onClose={()=>setModalGrupo(null)} onSave={salvarGrupo} onDelete={excluirGrupo}/>}
    </div>
  );
}
